<template>
  <div>
    <ion-header>
      <ion-toolbar>
        <ion-title>Add notes</ion-title>
        <ion-buttons slot="end">
          <ion-button @click="onClose">Done</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <ion-item>
        <ion-textarea
          ref="notes"
          class="notes"
          :value="notes"
          @input="notes = $event.target.value"
          placeholder="Write some notes..."
          autofocus="true"
        ></ion-textarea>
      </ion-item>
    </ion-content>
  </div>
</template>

<script>
export default {
  name: "NotesModal",
  props: ["data", "onNotes"],
  data() {
    return {
      notes: this.data || ""
    };
  },
  mounted() {
    setTimeout(() => {
      const notes = this.$refs.notes;
      if (notes) {
        notes.autoGrow = true;
        notes.setFocus();
      }
    }, 200);
  },
  methods: {
    onClose() {
      if (typeof this.onNotes === "function") {
        this.onNotes(this.notes);
      }
      this.$ionic.modalController.dismiss();
    }
  }
};
</script>
